/* eslint-disable react/no-array-index-key */

import { Notification } from '@coop/components';
import { useState } from 'react';

import { Helpers } from '../../../../utility/helpers';
import FlyInNavigation from '../atoms/FlyInNavigation';
import { FlyIn } from '../atoms/Modal';
import FlyInHeader from '../FlyInHeader/FlyInHeader';
import BuyableRecipe from './BuyableRecipe/BuyableRecipe';
import BuyableRecipeDetails from './BuyableRecipeDetails/BuyableRecipeDetails';
import type { BuyableRecipeFlyInViews } from './BuyableRecipeFlyIn.types';

const BuyableRecipeFlyIn = (
    props: Pick<React.ComponentProps<typeof FlyIn>, 'isOpen' | 'renderTrigger'> &
        Omit<BuyableRecipeFlyInBodyProps, 'onBuySuccess'>,
) => {
    const [notificationData, setNotificationData] = useState({ show: false, quantity: 0 });

    return (
        <>
            <Notification
                type="success"
                behaviour="autoclosing"
                show={notificationData.show}
                close={() =>
                    setNotificationData((prev) => ({ show: false, quantity: prev.quantity }))
                }
                message={`${notificationData.quantity} varor lades till i varukorgen.`}
            />
            <FlyIn
                isOpen={props.isOpen}
                close={props.onClose}
                renderTrigger={props.renderTrigger}
                sizePx={540}
            >
                <BuyableRecipeFlyInBody
                    viewType={props.viewType}
                    allowRecipePageRedirect={props.allowRecipePageRedirect}
                    defaultPortions={props.defaultPortions}
                    recipeId={props.recipeId}
                    recipeName={props.recipeName}
                    recipeType={props.recipeType}
                    analyticsListName={props.analyticsListName}
                    onClose={props.onClose}
                    onBuySuccess={(quantityAdded) => {
                        setNotificationData({
                            show: true,
                            quantity: quantityAdded,
                        });
                        props.onClose();
                    }}
                />
            </FlyIn>
        </>
    );
};

interface BuyableRecipeFlyInBodyProps {
    viewType: BuyableRecipeFlyInViews;
    allowRecipePageRedirect: boolean;
    defaultPortions: number;
    recipeId: string;
    recipeName: string;
    recipeType: 'recipe' | 'foodbox';
    analyticsListName: string;
    onClose: () => void;
    onBuySuccess: (quantityOfProductsAdded: number) => void;
}

const BuyableRecipeFlyInBody = (props: BuyableRecipeFlyInBodyProps) => {
    switch (props.viewType) {
        case 'both':
        case 'cart':
            return (
                <BuyableRecipe
                    recipeId={props.recipeId}
                    recipeName={props.recipeName}
                    recipeType={props.recipeType}
                    defaultPortions={props.defaultPortions}
                    viewType={props.viewType}
                    allowRecipePageRedirect={props.allowRecipePageRedirect}
                    onBuySuccess={props.onBuySuccess}
                    onClose={props.onClose}
                    analyticsListName={props.analyticsListName}
                />
            );
        case 'recipe':
            return (
                <BuyableRecipeDetails
                    recipeId={props.recipeId}
                    recipeType={props.recipeType}
                    allowRecipePageRedirect={props.allowRecipePageRedirect}
                    navigationSlot={
                        <FlyInHeader.Root
                            heading="Recept"
                            navigationSlot={<FlyInNavigation onClose={props.onClose} />}
                            hideBorderBottom
                        />
                    }
                />
            );
        default:
            return Helpers.exhaustiveCheck(props.viewType);
    }
};

export default BuyableRecipeFlyIn;
